import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LsDropdownComponent } from './components/ls-dropdown/ls-dropdown.component';
import { LsDropdownToggleComponent } from './components/ls-dropdown-toggle/ls-dropdown-toggle.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LsDropdownMenuComponent } from './components/ls-dropdown-menu/ls-dropdown-menu.component';

@NgModule({
    imports: [
        CommonModule,
        BsDropdownModule
    ],
    declarations: [
        LsDropdownComponent,
        LsDropdownToggleComponent,
        LsDropdownMenuComponent
    ],
    exports: [
        LsDropdownComponent,
        LsDropdownToggleComponent,
        LsDropdownMenuComponent
    ]
})
export class LsDropdownModule { }
